import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import {i18n} from 'src/i18n';

export default [
  {
    name: 'label',
    label: i18n('entities.employeeCategory.fields.label'),
    schema: schemas.string(i18n('entities.employeeCategory.fields.label'), {required: true}),
  },
  {
    name: 'description',
    label: i18n('entities.employeeCategory.fields.description'),
    schema: schemas.string(i18n('entities.employeeCategory.fields.description'), {}),
  },
];
